"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testUser = exports.ROLE_DEI = exports.ROLE_PROGRAMMING = exports.ROLE_ADMIN = exports.ROLE_QA = exports.ROLE_TAGGER = exports.User = exports.ROLE_NAME_DSS_PROGRAMMING = exports.ROLE_NAME_ADMIN = exports.ROLE_NAME_QA = exports.ROLE_NAME_TAGGER = exports.PERMISSION_APPROVE = exports.PERMISSION_DEBUG = exports.PERMISSION_PUBLISH = exports.PERMISSION_READ = exports.PERMISSION_WRITE = void 0;
const partial_myid_user_dto_1 = require("./dto/partial-myid-user.dto");
exports.PERMISSION_WRITE = 'WRITE';
exports.PERMISSION_READ = 'READ';
exports.PERMISSION_PUBLISH = 'PUBLISH';
exports.PERMISSION_DEBUG = 'DEBUG';
exports.PERMISSION_APPROVE = 'APPROVE TAGGING QUALITY';
exports.ROLE_NAME_TAGGER = 'Tagger';
exports.ROLE_NAME_QA = 'QA';
exports.ROLE_NAME_ADMIN = 'Admin';
exports.ROLE_NAME_DSS_PROGRAMMING = 'Programming';
class User {
    constructor(myIdUser, gssoMyid) {
        this.myIdUser = myIdUser;
        this.gssoMyid = gssoMyid;
    }
    get id() {
        return this.myIdUser['id.sapID'];
    }
    hasPermission(permission) {
        const roles = this.myIdUser.roles || [];
        return roles
            .flatMap(role => role.functionalAbilities.map(fa => fa.name))
            .includes(permission);
    }
}
exports.User = User;
exports.ROLE_TAGGER = {
    name: exports.ROLE_NAME_TAGGER,
    functionalAbilities: [{ name: exports.PERMISSION_READ }, { name: exports.PERMISSION_WRITE }],
};
exports.ROLE_QA = {
    name: exports.ROLE_NAME_QA,
    functionalAbilities: [
        { name: exports.PERMISSION_READ },
        { name: exports.PERMISSION_WRITE },
        { name: exports.PERMISSION_PUBLISH },
    ],
};
exports.ROLE_ADMIN = {
    name: exports.ROLE_NAME_ADMIN,
    functionalAbilities: [
        { name: exports.PERMISSION_READ },
        { name: exports.PERMISSION_WRITE },
        { name: exports.PERMISSION_PUBLISH },
        { name: exports.PERMISSION_DEBUG },
    ],
};
exports.ROLE_PROGRAMMING = {
    name: exports.ROLE_NAME_DSS_PROGRAMMING,
    functionalAbilities: [{ name: exports.PERMISSION_READ }, { name: exports.PERMISSION_APPROVE }],
};
exports.ROLE_DEI = {
    name: 'DEI',
    functionalAbilities: [
        {
            name: 'WRITE DEI',
        },
    ],
};
exports.testUser = new User(partial_myid_user_dto_1.TestMyIDUser, 'gsso-myid');
//# sourceMappingURL=user.js.map